import { IconButton } from '@mui/material';
import styled from 'styled-components';
import { ShowHideElementGridPart } from '../gridPartFactory/styles';

export const Container = styled.div``;
export const ContainerCardShopping = styled(ShowHideElementGridPart)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  position: relative;
`;

export const BodyCardShopping = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 0;

  > img {
    width: 100%;
    max-width: 185px;
    max-height: 185px;
    min-width: 185px;
    min-height: 185px;
    object-fit: contain;
  }
`;

export const AreaTitleCardShopping = styled.p`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.2rem;
  font-size: 0.9rem;
  margin: 0;
`;

export const TitleCardShopping = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-weight: bold;
`;
export const TextCardShopping = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-size: 0.8rem;
  line-height: 1.2rem;
  margin-bottom: 0.4rem;
`;

export const BoxButtonCart = styled(IconButton)`
  &&& {
    position: absolute !important;
    right: 0 !important;
    bottom: 0 !important;

    &:disabled {
      color: rgb(0 0 0 / 30%);
    }
  }
`;

